import { Outlet } from "react-router-dom";
import AdminSidebar from "@/components/AdminSidebar";
import { ThemeToggle } from "@/components/ThemeToggle";
import { SidebarInset, SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import HelpWidget from "@/help/HelpWidget";

export default function AdminLayout() {
  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full">
        <AdminSidebar />
        <SidebarInset>
          <header className="sticky top-0 z-40 flex h-14 items-center gap-3 border-b border-border/50 bg-background/80 backdrop-blur-xl px-4 md:px-6">
            <SidebarTrigger className="text-muted-foreground" />
            <div className="flex-1" />
            <ThemeToggle />
          </header>
          <main className="flex-1 pb-10">
            <Outlet />
          </main>
        </SidebarInset>
        <HelpWidget />
      </div>
    </SidebarProvider>
  );
}
